import { cohortSerilaizer } from '@/providers/serializers/cohort/cohort';
import { http } from '../http';

export class CohortAPI {

    private static INSTANCE = new CohortAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/groups/v1';

    private adminNamespace: string = 'api/admin/v1';

    public fetchCohortList(type: string, params: any = {}) {
        const endpoint = `${this.namespace}/flexible-groups/${type}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return cohortSerilaizer.normalizeCohortList(response.data);
        });
    }

    public fetchUserACL(param: any) {
        const endpoint = `${this.adminNamespace}/groups/user/${param.userId}/tenant/${param.tenantId}/acl`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return cohortSerilaizer.normalizeACLDemoList(response.data);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public updateUserACL(data: any) {
        const endpoint = `${this.adminNamespace}/groups/user/acl`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, data).then((response) => {
            return true;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

}

export const cohortAPI = CohortAPI.instance;
